import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  popover: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '5px',
    zIndex: 1000,
    background: 'linear-gradient(to bottom, #FFFFFF 0px, #FFFFFF 34px, #F5F5F8 36px, #F5F5F8 100% )',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    borderBottom: '1px solid rgba(44, 45, 62, 0.3)',
    height: '35px',
  },
  title: {
    padding: '10px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    color: '#2C2D3E',
  },
  comment: {
    padding: '10px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '13px',
    color: '#2C2D3E',
    overflowWrap: 'break-word',
    '& .MuiFormControl-root': {
      width: '100%'
    },
    '& .MuiInputBase-multiline': {
      padding: '7px'
    }
  },
  icons: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  actionIcon: {
    position: 'relative',
    color: '#3C419A',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  closeIcon: {
    position: 'relative',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  newComment: {
    width: 'calc(100% - 10px)',
    padding: '5px',
  },
  input: {
    '& .MuiOutlinedInput-multiline': {
      padding: '10px 2px 55px 10px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 400,
      color: '#2C2D3E',
      fontSize: '13px',
      background: '#FFFFFF',
      overflow: 'auto',
      height: '100%',
    },
  },
  inputReadOnly: {
    '& .MuiInput-underline:before': {
      border: 'none',
    },
    '& .MuiInput-underline:after': {
      border: 'none',
    },
    '& .MuiInput-underline:hover:before': {
      border: 'none',
    },
  },
  actonButtons: {
    display: 'flex',
    flexDirection: 'row',
    position: 'absolute',
    right: '10px',
    bottom: '10px',
  },
  signsCounter: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    color: '#2C2D3E',
    fontSize: '12px',
    position: 'absolute',
    left: '15px',
    bottom: '15px',
  },
}));
